import { PropertyData } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const addComps = createAction<PropertyData[]>('addComps');
